import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    firstname: yup.string().nullable().trim().label('Firstname'),
    lastname: yup.string().nullable().trim().label('Lastname'),
    email: yup.string().trim().email().required().label('Email'),
    password_api: yup.string().nullable().label('New Password'),
  })
  .required()

const resUserAccount = yupResolver(schema)

export default resUserAccount
